const NoPermissionsPage = () => <div> No permissions </div>

export default NoPermissionsPage
